<template>
  <div>
    <el-image style="width: 100%; height: 18rem" :src="item.ImgFile" fit="cover" lazy>
      <div
        slot="error"
        style="text-align: center; line-height: 18rem; font-size: 3rem; color: #999"
      >
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>

    <div>
      <!-- <p id="demo">DEMO</p> -->
      <!-- {{ params }} -->
      <!-- {{ item }} -->
      <div style="padding: 1rem">
        <div class="itemname">
          {{ dscpItemName(item) }}
        </div>
        <div style="line-height: 1.5rem">
          <span v-if="!params.ItemNameUseRemark">
            <span v-html="item.Remark"></span>
          </span>
        </div>
        <div style="font-size: 1.2rem; margin: 1rem 0 1rem 0">${{ item.Price1 }}</div>
        <!-- {{ item.SelectedPrice }}
      {{ item.Prices }}
      /{{ item.Prices[item.SelectedPrice].Price }} -->
        <!-- {{ collapse }} -->
      </div>
      <van-radio-group v-model="item.SelectedPrice" v-if="item.Prices.length > 1">
        <van-radio :name="index" v-for="(pc, index) in item.Prices" :key="index">
          <div style="font-size: 1rem">
            <span style="margin-right: 0.5rem">{{ pc.PriceCap }}</span>
            <span style="color: orangered">${{ pc.Price }} </span>
          </div>
        </van-radio>
      </van-radio-group>

      <van-collapse v-model="collapse">
        <van-collapse-item :name="index" v-for="(s2, index) in item.S2" :key="s2.lv">
          <template slot="title">
            <span class="title">
              {{ getLvDscp(s2.lv) }}
              <!-- /{{ getS2SelectedCount(s2.items) }} -->
            </span>
            <!-- <span :class="{ true: red }" v-if="s2.lock"> (必需選擇{{s2.count}}項)</span> -->
            <span
              :class="{
                red: getS2SelectedCount(s2.items) != s2.count,
                tip: getS2SelectedCount(s2.items) == s2.count,
              }"
              v-if="s2.lock"
            >
              (必需選擇{{ s2.count }}項)</span
            >
            <span v-else>
              <span
                :class="{
                  red: getS2SelectedCount(s2.items) > s2.count,
                  tip: getS2SelectedCount(s2.items) <= s2.count,
                }"
                v-if="Number(s2.count) > 0"
                >(最多選擇{{ s2.count }}項)</span
              >
              <span v-else>(請選擇)</span>
            </span>
          </template>
          <div>
            <!-- {{ s2 }} -->
          </div>
          <div v-for="it in s2.items" :key="it.ItemName">
            <!-- <van-radio-group v-model="activeNames1">
              <van-radio :name="item.ItemName">{{item.ItemName}}</van-radio>
            </van-radio-group> -->

            <div style="font-size: 1rem" v-if="it.ItemType.substr(0, 1) == 'Q'">
              <span v-if="it.value > 0">
                <el-button
                  style="font-size: 1.5rem"
                  type="text"
                  icon="el-icon-remove-outline"
                  circle
                  @click="it.value--"
                >
                </el-button>
                <span style="font-size: 1.5rem">{{ it.value }}</span>
              </span>
              <el-button
                style="font-size: 1.5rem"
                type="text"
                icon="el-icon-circle-plus-outline"
                circle
                @click="it.value++"
                :disabled="isStopSale(it)"
              >
              </el-button>
              {{ it.ItemName }}
              <!-- <span style="color: orangered"> +${{ it.Price }}</span> -->
              <span style="color: orangered" v-if="!isStopSale(it)">
                +${{ it.Price }}</span
              >
              <span style="margin-left: 0.5rem" v-else>
                <van-tag type="primary" color="#666" round size="large">
                  已售完
                </van-tag></span
              >
            </div>
            <div v-else>
              <van-checkbox
                v-model="it.value"
                :disabled="isStopSale(it)"
                shape="square"
                @change="onChange(it)"
              >
                {{ it.ItemName }}
                <span style="color: orangered" v-if="!isStopSale(it)">
                  +${{ it.Price }}</span
                >
                <span style="margin-left: 0.5rem" v-else>
                  <van-tag type="primary" color="#666" round size="large">
                    已售完
                  </van-tag></span
                >
                <!-- <span @click="showS2Note(it)">口味</span> -->
              </van-checkbox>
              <div style="padding-left: 1.8rem; font-size: 1rem">
                <!-- {{ it.Notes }} -->
                <span v-for="nt in it.Notes" :key="nt.ItemNote">
                  <van-tag plain type="primary" size="large" v-if="nt.value">{{
                    nt.ItemNote
                  }}</van-tag>
                </span>
              </div>
              <div
                style="padding-left: 1.8rem; font-size: 1rem"
                v-for="ss in it.S2"
                :key="ss.lv"
              >
                <div v-for="si in ss.items" :key="si.ItemName">
                  <!-- {{ si }} -->
                  <span v-if="Number(si.value) > 0">
                    {{ si.ItemName }} X {{ Number(si.value) }}
                    <span style="color: orangered">+${{ si.Price }}</span>
                  </span>
                </div>
              </div>
              <!-- {{ it }} -->
            </div>
          </div>
        </van-collapse-item>

        <van-collapse-item name="note" v-if="item.Notes.length > 0">
          <template slot="title">
            <span class="title">口味備註</span>
          </template>
          <div v-for="(inote, index) in item.Notes" :key="index">
            <span v-if="index < 8">
              <van-checkbox v-model="inote.value" shape="square">
                {{ inote.ItemNote }}
                <span style="color: orangered" v-if="Number(inote.Remark) > 0">
                  +${{ inote.Remark }}</span
                >
              </van-checkbox>
            </span>
          </div>

          <van-button
            plain
            type="info"
            size="large"
            v-if="item.Notes.length > 8 && !item.showmore"
            @click="item.showmore = true"
            >顯示更多</van-button
          >

          <div v-for="(inote, index) in item.Notes" :key="index">
            <span v-if="index >= 8 && item.showmore">
              <van-checkbox v-model="inote.value" shape="square">
                {{ inote.ItemNote }}
              </van-checkbox>
            </span>
          </div>
        </van-collapse-item>
      </van-collapse>

      <div class="qty" style="text-align: center">
        <el-button
          type="text"
          icon="el-icon-remove-outline"
          circle
          :disabled="item.QtyLock"
          @click="subQty()"
        >
        </el-button>
        <span @click="numberPicker(item.Qty)">{{ item.Qty }}</span>
        <span style="font-size: 2rem">{{ custcount }}</span>
        <el-button
          type="text"
          icon="el-icon-circle-plus-outline"
          circle
          :disabled="item.QtyLock"
          @click="addQty()"
        >
        </el-button>
        <div class="red" style="font-size:1rem">點擊數字可輸入數量</div>
      </div>
    </div>

    <!-- frmItemSS -->
    <van-popup
      :close-on-click-overlay="false"
      v-model="frmItemSS.visible"
      position="bottom"
      :style="{ height: '100%' }"
      id="m2"
    >
      <van-nav-bar
        left-arrow
        left-text="取消"
        @click-left="onCancel"
        :title="crtItemSS.ItemName"
        placeholder
        fixed
        :border="false"
      />
      <ItemSS :itemss="crtItemSS" :params="params" />
      <van-tabbar v-model="active" placeholder>
        <van-button type="info" size="large" @click="addItemSS()">確認</van-button>
      </van-tabbar>
    </van-popup>

    <!-- frmNote -->
    <van-popup
      v-model="frmS2Note.visible"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-nav-bar :title="frmS2Note.title" placeholder />
      <div style="padding: 1rem">
        <div v-for="(inote, index) in frmS2Note.Notes" :key="index">
          <span v-if="index < 8">
            <van-checkbox v-model="inote.value" shape="square">
              {{ inote.ItemNote }}
            </van-checkbox>
          </span>
        </div>
      </div>
      <van-tabbar placeholder>
        <van-button type="info" size="large" @click="closeS2Note()">確認</van-button>
      </van-tabbar>
    </van-popup>

    <!-- numberPicker -->
    <van-number-keyboard
      :show="kb.visible"
      v-model="kb.value"
      :title="'份數:' + kb.value"
      theme="custom"
      extra-key="."
      close-button-text="確認"
      @blur="kb.visible = false"
      @close="ok"
      :maxlength="3"
    />
  </div>
</template>
<style scoped>
.qty {
  font-size: 3em;
  margin: 1rem 0 1rem 0;
}
.el-button {
  font-size: 3rem;
}
.van-checkbox {
  font-size: 1rem;
  height: 3rem;
}
.van-radio {
  font-size: 1rem;
  height: 3rem;
}
.red {
  color: red;
}
.tip {
  color: #555;
}
.itemname {
  font-size: 1.4rem;
  /* font-weight: bold; */
}
.title {
  color: #666;
  font-size: 1rem;
}
.van-tag {
  margin: 0 0 0 0.2rem;
}
</style>
<script>
import ItemSS from "@/components/ItemSS.vue";
export default {
  name: "Item",
  components: {
    ItemSS,
  },
  props: {
    msg: String,
    item: Object,
    collapse: Object,
    showmore: Boolean,
    params: Object,
  },
  data() {
    return {
      // qty: 1,
      active: 0,
      frmItemSS: { visible: false },
      frmS2Note: { visible: false, title: "口味備註", Notes: [] },
      activeNames: ["1", "2"],
      activeNames1: "1",
      dscp: "",
      line: "",
      x: 0,
      crtItemSS: [],
      // collapse: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, "note"],
      kb: { visible: false, value: 0 },
    };
  },
  methods: {
    ok: function () {
      this.item.Qty = Number(this.kb.value);
      this.kb.visible = false;
    },
    numberPicker: function (qty) {
      this.kb.visible = true;
      this.kb.value = qty.toString();
    },
    showS2Note: function (obj) {
      var app = this;
      // alert(JSON.stringify(obj));
      app.frmS2Note.title = obj.ItemName + " 口味選擇";
      app.frmS2Note.Notes = obj.Notes;
      app.frmS2Note.visible = true;
    },
    closeS2Note: function () {
      var app = this;
      app.frmS2Note.visible = false;
    },
    onChange: function (obj) {
      // alert("obj:" + JSON.stringify(obj));
      let itemtype = obj.ItemType;
      if (itemtype == "SS") {
        if (obj.value) {
          this.crtItemSS = obj;
          this.showItemSS(obj);
        } else {
          for (let i = 0; i < obj.S2.length; i++) {
            for (let j = 0; j < obj.S2[i].items.length; j++) {
              obj.S2[i].items[j].value = false;
            }
          }
        }
      } else {
        if (obj.value) {
          if (obj.Notes.length > 0) {
            this.showS2Note(obj);
          }
        } else {
          for (let i = 0; i < obj.Notes.length; i++) {
            obj.Notes[i].value = false;
          }
        }
      }
      return;
    },

    showItemSS: function (obj) {
      var app = this;
      console.log(obj);
      app.frmItemSS.visible = true;
    },
    closeItemSS: function () {
      this.scrollToTop();
      this.frmItemSS.visible = false;
    },
    onCancel: function () {
      var obj = this.crtItemSS;
      obj.value = false;
      for (let i = 0; i < obj.S2.length; i++) {
        for (let j = 0; j < obj.S2[i].items.length; j++) {
          obj.S2[i].items[j].value = false;
        }
      }
      this.scrollToTop();
      this.frmItemSS.visible = false;
    },
    addItemSS: function () {
      var app = this;
      if (app.checkData()) {
        this.closeItemSS();
      } else {
        app.$dialog.alert({
          message: "附餐數量錯誤",
        });
      }
    },

    checkData: function () {
      var s2 = this.crtItemSS.S2;
      var checkData = false;
      for (let i = 0; i < s2.length; i++) {
        var count = s2[i].count;
        var items = s2[i].items;
        var lock = s2[i].lock;
        var selectedCount = this.getS2SelectedCount(items);
        if (lock) {
          if (count != selectedCount) {
            checkData = false;
            return checkData;
          }
        } else {
          // alert(count + "," + selectedCount);
          if (Number(count) != 0) {
            if (Number(count) < selectedCount) {
              checkData = false;
              return checkData;
            }
          }
        }
      }
      checkData = true;
      return checkData;
    },
    scrollToTop() {
      var m2 = document.getElementById("m2");
      if (m2 != null) {
        m2.scrollTo(0, 0);
      }
    },
    addQty() {
      this.item.Qty++;
      if (this.item.Qty >= 999) {
        this.item.Qty = 999;
      }
    },
    subQty() {
      this.item.Qty--;
      if (this.item.Qty <= 1) {
        this.item.Qty = 1;
      }
    },
    getS2SelectedCount(items) {
      let count = 0;
      for (let i = 0; i < items.length; i++) {
        if (Number(items[i].value) > 0) {
          count += Number(items[i].value);
        }
      }
      return count;
    },
    getLvDscp(name) {
      if (name == undefined) {
        name = "";
      }
      var n = name.indexOf("_");
      var str = "";
      if (n > 0) {
        str = name.substr(n + 1);
      }
      return str;
    },
    isStopSale: function (obj) {
      if (obj.length == 0 || obj == undefined) {
        return true;
      }
      var kptype = obj.KPtype;
      if (kptype.substr(0, 1) == "-") {
        return true;
      }

      return false;
    },
    dscpItemName(obj) {
      var itemname = obj.ItemName;
      if (this.params.ItemNameUseRemark) {
        if (obj.Remark != "" && obj.Remark != "AN") {
          itemname = obj.Remark;
        }
      }
      return itemname;
    },
    // getS2: function (obj, callback) {
    //   //取得品項附餐項目
    //   let data = [];
    //   let level = []; //附餐階層列表
    //   let tmp = [];

    //   //取得階層列表  ex: [ "LV1_升級套餐", "LV2_主食加點", "LV3_甜點加點", "LV4_湯品加點" ]
    //   let menuitems2 = [];
    //   // menuitems2 = [{"TypeNo":"10161","ItemNo":"1","ItemName":"原味蔬菜-","ItemType":"A1","Price1":"0","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"2","ItemName":"昆布柴魚-","ItemType":"A1","Price1":"30","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"3","ItemName":"壽喜鍋-","ItemType":"A1","Price1":"50","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"4","ItemName":"辣味噌-","ItemType":"A1","Price1":"50","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"5","ItemName":"韓式辣味-","ItemType":"A1","Price1":"50","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"6","ItemName":"酸白菜-","ItemType":"A1","Price1":"60","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"7","ItemName":"養生蒙古-","ItemType":"A1","Price1":"60","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"8","ItemName":"泰式酸辣-","ItemType":"A1","Price1":"60","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"9","ItemName":"冬蟲夏草-","ItemType":"A1","Price1":"70","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"10","ItemName":"藥膳何首烏-","ItemType":"A1","Price1":"70","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"11","ItemName":"咖哩湯-","ItemType":"A1","Price1":"70","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"12","ItemName":"麻辣湯-","ItemType":"A1","Price1":"79","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"13","ItemName":"茄汁牛奶-","ItemType":"A1","Price1":"80","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"14","ItemName":"墨魚牛奶-","ItemType":"A1","Price1":"80","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"15","ItemName":"麻辣牛奶-","ItemType":"A1","Price1":"89","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"16","ItemName":"牛奶-","ItemType":"A1","Price1":"89","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"19","ItemName":"白開水-","ItemType":"A1","Price1":"0","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"20","ItemName":"辣味鮮蟹-","ItemType":"A1","Price1":"129","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"},{"TypeNo":"10161","ItemNo":"21","ItemName":"原味鮮蟹-","ItemType":"A1","Price1":"129","Price2":"0.01","Price3":"0","KPtype":"K1","CtrlFlag":"LV1","ItemCode":"","ImgFile":"","Remark":"單人鍋","AvailTime":"","OpenCode":"N"}];
    //   var app = this;
    //   app.$http
    //     .get("./menuitems2", { params: { itemname: obj.ItemName } })
    //     .then((response) => {
    //       menuitems2 = response.data;
    //       alert(menuitems2.length);

    //       for (let i = 0; i < menuitems2.length; i++) {
    //         if (menuitems2[i].Remark == obj.ItemName) {
    //           let exist = false;
    //           tmp.push(menuitems2[i]);
    //           for (let j = 0; j < level.length; j++) {
    //             if (level[j] == menuitems2[i].CtrlFlag) {
    //               exist = true;
    //               break;
    //             }
    //           }
    //           if (!exist) {
    //             level.push(menuitems2[i].CtrlFlag);
    //             level.sort();
    //           }
    //         }
    //       }
    //       // alert(level);
    //       let arr = obj.CtrlFlag.split("/");

    //       for (let i = 0; i < level.length; i++) {
    //         let row = {};
    //         row.lv = level[i];
    //         row.count = 0;
    //         row.lock = false;
    //         row.value = false;
    //         app.$set(row, "value", false);

    //         if (i < arr.length) {
    //           row.count = arr[i];
    //           if (row.count.substr(-1) == "=") {
    //             row.lock = true;
    //             row.count = row.count.substr(0, 1);
    //           }
    //         }
    //         row.items = [];
    //         for (let j = 0; j < tmp.length; j++) {
    //           if (tmp[j].CtrlFlag == level[i]) {
    //             let item = {};
    //             item.ItemName = tmp[j].ItemName;
    //             item.Level = tmp[j].CtrlFlag;
    //             item.Price = tmp[j].Price1;
    //             item.KPtype = tmp[j].KPtype;
    //             item.ItemType = tmp[j].ItemType;
    //             item.value = false;

    //             if (item.ItemType.substr(0, 1) == "Q") {
    //               var qty = Number(item.ItemType.substr(1));
    //               if (qty == undefined) {
    //                 qty = 0;
    //               }
    //               if (item.KPtype.substr(0, 1) == "-") {
    //                 qty = 0;
    //               }
    //               item.value = qty;
    //             } else if (item.ItemType.substr(0, 1) == "V") {
    //               item.value = true;
    //               if (item.KPtype.substr(0, 1) == "-") {
    //                 item.value = false;
    //               }
    //             }

    //             row.items.push(item);
    //           }
    //         }
    //         data.push(row);
    //       }
    //       // alert("return data:" + JSON.stringify(data));
    //       // return data;
    //       callback(null, data);
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       app.$dialog.alert({
    //         message: error,
    //       });
    //       callback(error);
    //     });
    // },
  },
};
</script>
